
  import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
  import Util from '@/lib/util';
  import AbpBase from '@/lib/abpbase';
  import * as proxy from '@/lib/service-proxies/service-proxies';
  import AppConsts from '@/lib/appconst';
  import PagedFilterAndSortedRequest from '@/store/entities/page-request';
  import pagelist from '@/components/pagelistcomponent';
  @Component({
    components: {  }
  })
  export default class suppliermanage extends pagelist {
    get prox() {
      return new proxy.RealBalanceLogServiceProxy();
    }
    input: proxy.RealBalanceLogPageInputDto = new proxy.RealBalanceLogPageInputDto();
    sub_id = 0;
    createOrEditShow = false;
    BalanceTypes=[];
    createrange=[];
    columns = [
      {
        type: 'selection',
        width: 60,
        align: 'center'
      },
      
      {
        title: '关联单号',
        key: 'tid',
        width:240
      },
      {
      title:'商户单号',
      key:'merchantTid',
      width:240
    },
      {
          title:'变动金额',
          key:'money'
      },
    {
        title:'变动前',
        key:'balance'
    },
    {
        title:'变动后',
        key:'afterBalance'
    },
    
      {
          title:'备注',
          key:'comment'
      },
      {
        title: '创建时间',
        key: 'creationTime',
        width:180
      }
    ];
    exportrecord(){
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    this.prox.export(this.input).then((x) => {
      location.href =
        AppConsts.remoteServiceBaseUrl +
        '/File/DownloadTempFile?FileToken=' +
        x.fileToken +
        '&fileName=' +
        x.fileName +
        '&fileType=' +
        x.fileType;
    });
  }
    fetchDataList(
      request: PagedFilterAndSortedRequest,
      pageNumber: number,
      finishedCallback: Function
    ): void {
      this.input.skipCount = request.skipCount;
      this.input.maxResultCount = request.maxResultCount;
      this.input.sorting = request.sorting;
      this.input.createStartTime=this.createrange[0];
      this.input.createEndTime=this.createrange[1];
      this.prox.queryModelList(this.input).then(x => {
        console.log(x.items);
        this.dataList = x.items;
        this.showPaging(x);
      });
    }
     
    getpage() {
      this.OnInit();
    }
    async created() {
      //this.createrange = [new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime()), new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime() + 86400000)]
      this.createrange = [
      new Date(new Date(new Date().toLocaleDateString()).getTime()),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    ];
      new proxy.CommonServiceProxy().getEnumKeyValue('BalanceTypeEnum').then(x => {
      this.BalanceTypes = x;
    })
      this.getpage();
    }
    
  }
  